// extracted by mini-css-extract-plugin
export default {"p-paginator":"Table_p-paginator__7Uz+q","p-datatable":"Table_p-datatable__76Q4u","table":"Table_table__YUzYe","amountField":"Table_amountField__Akn4u"};